/* RENASCIA · theme.js */
(() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const RN = window.RN || { routes: {} };
  const CART_SECTION = 'rn-cart-drawer';

  const money = (cents) =>
    (Number(cents) / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const esc = (s) =>
    String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

  /* ---------- Aviso emergente ---------- */
  const toastEl = $('.toast');
  let toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.hidden = true; }, 3600);
  }

  /* ---------- Paneles laterales ---------- */
  const openDrawers = new Set();
  let searchOpen = false;
  let lastFocus = null;

  function syncOverlay() {
    document.body.classList.toggle('has-overlay', openDrawers.size > 0 || searchOpen);
  }

  function openDrawer(name) {
    const d = $(`[data-drawer="${name}"]`);
    if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open')));
    openDrawers.add(d);
    syncOverlay();
    const panel = $('.drawer__panel', d);
    if (panel) setTimeout(() => panel.focus({ preventScroll: true }), 50);
    $$(`[aria-controls="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    return true;
  }

  function closeDrawer(d) {
    d.classList.remove('is-open');
    openDrawers.delete(d);
    syncOverlay();
    $$(`[aria-controls="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    setTimeout(() => { if (!d.classList.contains('is-open')) d.hidden = true; }, 400);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { const d = closer.closest('[data-drawer]'); if (d) closeDrawer(d); }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      openDrawers.forEach(closeDrawer);
      closeSearch();
      closeMegas();
      return;
    }
    if (e.key !== 'Tab' || !openDrawers.size) return;
    const d = Array.from(openDrawers).pop();
    const panel = $('.drawer__panel', d);
    const focusables = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea', panel)
      .filter((el) => el.offsetParent !== null);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Cabecera ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const megas = $$('[data-mega]');
  function closeMegas(except) {
    megas.forEach((m) => {
      if (m === except) return;
      m.classList.remove('is-open');
      const b = $('.nav__link', m);
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  megas.forEach((m) => {
    const btn = $('.nav__link', m);
    let timer;
    const open = () => { clearTimeout(timer); closeMegas(m); m.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    const close = () => { timer = setTimeout(() => { m.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 140); };
    btn.addEventListener('click', () => (m.classList.contains('is-open') ? closeMegas() : open()));
    if (window.matchMedia('(hover: hover)').matches) {
      m.addEventListener('mouseenter', open);
      m.addEventListener('mouseleave', close);
    }
    m.addEventListener('focusout', (e) => { if (!m.contains(e.relatedTarget)) close(); });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('[data-mega]')) closeMegas(); });

  const announce = $('[data-announce]');
  if (announce) {
    const items = $$('.announce__item', announce);
    if (items.length > 1) {
      let i = 0;
      setInterval(() => {
        if (window.innerWidth >= 990) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    }
  }

  /* ---------- Búsqueda (índice local, funciona también con productos sin listar) ---------- */
  const searchModal = $('#SearchModal');
  let searchIndex = null;
  function getIndex() {
    if (searchIndex) return searchIndex;
    try { searchIndex = JSON.parse(($('[data-search-index]') || {}).textContent || '[]'); } catch (err) { searchIndex = []; }
    return searchIndex;
  }
  function matchIndex(q) {
    const terms = norm(q).split(/\s+/).filter(Boolean);
    if (!terms.length) return [];
    return getIndex().filter((p) => {
      const hay = norm(`${p.t} ${p.k}`);
      return terms.every((t) => hay.includes(t));
    });
  }
  function openSearch() {
    if (!searchModal) return;
    searchModal.hidden = false;
    searchOpen = true;
    syncOverlay();
    const input = $('[data-search-input]', searchModal);
    setTimeout(() => input && input.focus(), 30);
  }
  function closeSearch() {
    if (!searchModal || !searchOpen) return;
    searchModal.hidden = true;
    searchOpen = false;
    syncOverlay();
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    else if (e.target.closest('[data-search-close]')) closeSearch();
  });
  if (searchModal) {
    const input = $('[data-search-input]', searchModal);
    const out = $('[data-search-results]', searchModal);
    const suggest = $('[data-search-suggest]', searchModal);
    input.addEventListener('input', () => {
      const q = input.value.trim();
      if (!q) { out.innerHTML = ''; suggest.hidden = false; return; }
      const hits = matchIndex(q).slice(0, 6);
      suggest.hidden = hits.length > 0;
      out.innerHTML = hits.length
        ? hits.map((h) => `<a class="search-hit" href="${esc(h.u)}">${h.i ? `<img src="${esc(h.i)}" alt="" width="56" height="56" loading="lazy">` : '<span></span>'}<span class="search-hit__t">${esc(h.t)}</span><span class="search-hit__p">${esc(h.p)}</span></a>`).join('')
        : `<p class="search-empty">Sin coincidencias para «${esc(q)}». Pulsa Intro para buscar en toda la tienda.</p>`;
    });
  }
  const searchEmpty = $('[data-search-empty]');
  if (searchEmpty) {
    const hits = matchIndex(searchEmpty.dataset.terms || '');
    if (hits.length) {
      $('[data-local-results]', searchEmpty).innerHTML = hits.map((h) => `
        <article class="card">
          <a class="card__media" href="${esc(h.u)}" tabindex="-1" aria-hidden="true">${h.i ? `<img class="card__img" src="${esc(String(h.i).replace('width=160', 'width=600'))}" alt="" loading="lazy">` : ''}</a>
          <div class="card__body">
            <h3 class="card__title"><a class="card__link" href="${esc(h.u)}">${esc(h.t)}</a></h3>
            <div class="card__foot"><div class="price"><span class="price__now">${esc(h.p)}</span></div></div>
          </div>
        </article>`).join('');
      const none = $('[data-local-none]', searchEmpty);
      if (none) none.hidden = true;
    }
  }

  /* ---------- Cesta ---------- */
  const cartDrawer = () => $('#CartDrawer');

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = Number(count) === 0;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  function renderDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-panel]');
    const current = document.querySelector('#CartDrawer [data-cart-panel]');
    if (!fresh || !current) return;
    current.innerHTML = fresh.innerHTML;
    current.dataset.cartCountValue = fresh.dataset.cartCountValue;
    updateCount(Number(fresh.dataset.cartCountValue || 0));
    refreshEta();
  }

  async function refreshCart() {
    try {
      const base = (RN.routes.root || '/').replace(/\/$/, '');
      const res = await fetch(`${base}/?sections=${CART_SECTION}`, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      renderDrawer(data[CART_SECTION]);
    } catch (err) { /* sin conexión: se mantiene el estado actual */ }
  }

  async function addItems(items, btn) {
    if (!items.length) return;
    if (btn) btn.classList.add('is-loading');
    try {
      const res = await fetch(`${RN.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: CART_SECTION })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || '');
      if (!cartDrawer() || RN.cartType !== 'drawer') { window.location.href = RN.routes.cart; return; }
      if (data.sections && data.sections[CART_SECTION]) renderDrawer(data.sections[CART_SECTION]);
      else await refreshCart();
      openDrawer('cart');
      if (btn) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1600);
      }
    } catch (err) {
      if (btn) btn.classList.remove('is-loading');
      toast(err.message || 'No se ha podido añadir a la cesta. Inténtalo de nuevo.');
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-add-form]');
    if (!form || RN.cartType !== 'drawer' || !cartDrawer()) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Math.max(1, Number(fd.get('quantity') || 1));
    addItems([{ id, quantity }], e.submitter || form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', async (e) => {
    const toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && cartDrawer() && RN.cartType === 'drawer') { e.preventDefault(); openDrawer('cart'); return; }

    const qtyBtn = e.target.closest('[data-line-qty]');
    if (!qtyBtn) return;
    const line = qtyBtn.closest('[data-line]');
    if (!line) return;
    line.style.opacity = '.5';
    try {
      const res = await fetch(`${RN.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line.dataset.line), quantity: Math.max(0, Number(qtyBtn.dataset.lineQty)), sections: CART_SECTION })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || '');
      if (data.sections && data.sections[CART_SECTION]) renderDrawer(data.sections[CART_SECTION]);
      else await refreshCart();
    } catch (err) {
      line.style.opacity = '';
      toast(err.message || 'No se ha podido actualizar la cesta.');
    }
  });

  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });

  /* Selectores de cantidad (ficha y página de cesta) */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.closest('[data-qty]') && b.closest('[data-qty]').querySelector('input');
    if (!input) return;
    const min = Number(input.min || 0);
    const max = Number(input.max || 999);
    const step = Number(b.dataset.qtyStep);
    const next = Math.min(max, Math.max(min, Number(input.value || 0) + step));
    if (next === Number(input.value)) {
      if (step > 0 && max < 99) toast(`Solo quedan ${max} unidades disponibles`);
      return;
    }
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-autosubmit]');
    if (!input || !input.form) return;
    clearTimeout(input._timer);
    input._timer = setTimeout(() => input.form.submit(), 400);
  });

  /* ---------- Fecha estimada de entrega (hora de Madrid) ---------- */
  const DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const holidays = new Set((RN.holidays || []).map((s) => String(s).trim()).filter(Boolean));
  const ymd = (d) => `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
  const isBusinessDay = (d) => d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !holidays.has(ymd(d));
  function addBusinessDays(date, n) {
    const d = new Date(date.getTime());
    let added = 0;
    while (added < n) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isBusinessDay(d)) added += 1;
    }
    return d;
  }
  function madridNow() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    const get = (type) => Number((parts.find((p) => p.type === type) || {}).value || 0);
    return { y: get('year'), m: get('month'), d: get('day'), h: get('hour'), min: get('minute') };
  }
  function computeEta() {
    const now = madridNow();
    const today = new Date(Date.UTC(now.y, now.m - 1, now.d));
    const cutoff = Number(RN.cutoffHour || 14);
    const sameDay = isBusinessDay(today) && now.h < cutoff;
    const ship = sameDay ? today : addBusinessDays(today, 1);
    const from = addBusinessDays(ship, Number(RN.minDays ?? 1));
    const to = addBusinessDays(ship, Number(RN.maxDays ?? 2));
    const minutesLeft = sameDay ? cutoff * 60 - (now.h * 60 + now.min) : null;
    return { from, to, minutesLeft };
  }
  function formatRange(a, b) {
    const day = (d, withMonth) => `${DAYS[d.getUTCDay()]} ${d.getUTCDate()}${withMonth ? ` de ${MONTHS[d.getUTCMonth()]}` : ''}`;
    if (ymd(a) === ymd(b)) return `el ${day(a, true)}`;
    const sameMonth = a.getUTCMonth() === b.getUTCMonth();
    return `entre el ${day(a, !sameMonth)} y el ${day(b, true)}`;
  }
  function refreshEta() {
    const eta = computeEta();
    const range = formatRange(eta.from, eta.to);
    let text = `Pídelo hoy y recíbelo <b>${range}</b>.`;
    if (eta.minutesLeft && eta.minutesLeft > 0) {
      const h = Math.floor(eta.minutesLeft / 60);
      const m = eta.minutesLeft % 60;
      text = `Pídelo en las próximas <b>${h > 0 ? `${h} h ${m} min` : `${m} min`}</b> y recíbelo <b>${range}</b>.`;
    }
    $$('[data-eta]').forEach((el) => { el.innerHTML = text; });
    const left = eta.minutesLeft && eta.minutesLeft > 0 ? eta.minutesLeft : 0;
    const leftText = left ? (Math.floor(left / 60) > 0 ? `${Math.floor(left / 60)} h ${left % 60} min` : `${left} min`) : '';
    $$('[data-eta-short]').forEach((el) => {
      el.innerHTML = left ? `Sale hoy si finalizas en las próximas <b>${leftText}</b>` : `Recíbelo ${range}`;
    });
    $$('[data-eta-bar]').forEach((el) => {
      el.textContent = left ? `Pide en las próximas ${leftText} y tu pedido sale hoy` : `Pide hoy y recíbelo ${formatShortRange(eta.from, eta.to)}`;
    });
  }
  function formatShortRange(a, b) {
    const day = (x) => `${DAYS[x.getUTCDay()].slice(0, 3)}. ${x.getUTCDate()}`;
    return ymd(a) === ymd(b) ? `el ${day(a)}` : `entre el ${day(a)} y el ${day(b)}`;
  }
  refreshEta();
  setInterval(refreshEta, 60000);

  /* ---------- Galería de producto ---------- */
  $$('[data-gallery]').forEach((g) => {
    const track = $('[data-gallery-track]', g);
    const slides = track ? $$('.gallery__slide', track) : [];
    if (slides.length < 2) return;
    const thumbs = $$('[data-thumb]', g);
    const dots = $$('.gallery__dots span', g);
    let current = 0;
    const mark = (i) => {
      current = i;
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const go = (i) => {
      const index = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
      mark(index);
    };
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.thumb))));
    const prev = $('[data-gallery-prev]', g);
    const next = $('[data-gallery-next]', g);
    if (prev) prev.addEventListener('click', () => go(current - 1));
    if (next) next.addEventListener('click', () => go(current + 1));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) mark(i);
      });
    }, { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
  });

  $$('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.location.replace(url.toString());
    });
  });

  /* ---------- Barra de compra fija ---------- */
  const sticky = $('[data-sticky-atc]');
  const mainAtc = $('[data-main-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    new IntersectionObserver(([entry]) => {
      const show = mobileQuery.matches ? !entry.isIntersecting : (!entry.isIntersecting && entry.boundingClientRect.top < 0);
      sticky.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-sticky-atc', show);
    }).observe(mainAtc);
    const stickyBtn = $('[data-sticky-add]', sticky);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const form = mainAtc.form;
        if (!form) return;
        if (form.requestSubmit) form.requestSubmit(mainAtc);
        else form.submit();
      });
    }
  }

  /* ---------- Rutina combinada ---------- */
  $$('[data-bundle]').forEach((bundle) => {
    const checks = $$('[data-bundle-check]', bundle);
    const total = $('[data-bundle-total]', bundle);
    const btn = $('[data-bundle-add]', bundle);
    const label = btn && btn.querySelector('span');
    const calc = () => {
      let sum = 0;
      let count = 0;
      checks.forEach((c) => {
        const item = c.closest('.bundle__item');
        if (item) item.classList.toggle('is-off', !c.checked);
        if (c.checked) { sum += Number(c.dataset.price); count += 1; }
      });
      if (total) total.textContent = money(sum);
      if (btn) btn.disabled = count === 0;
      if (label) label.textContent = count > 1 ? `Añadir las ${count} fórmulas` : 'Añadir a la cesta';
    };
    checks.forEach((c) => c.addEventListener('change', calc));
    calc();
    if (btn) {
      btn.addEventListener('click', () => {
        const items = checks.filter((c) => c.checked).map((c) => ({ id: Number(c.dataset.variant), quantity: 1 }));
        addItems(items, btn);
      });
    }
  });

  /* ---------- Pestañas ---------- */
  $$('[data-tabs]').forEach((wrap) => {
    const tabs = $$('[role="tab"]', wrap);
    const panels = tabs.map((t) => document.getElementById(t.getAttribute('aria-controls')));
    const select = (i, focus) => {
      tabs.forEach((t, k) => {
        const on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[k]) panels[k].hidden = !on;
      });
      if (focus) tabs[i].focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % tabs.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
      });
    });
  });

  /* ---------- Colección: filtros por necesidad y orden ---------- */
  $$('[data-collection]').forEach((wrap) => {
    const grid = $('[data-grid]', wrap);
    if (!grid) return;
    const cards = $$('[data-card]', grid);
    cards.forEach((card, i) => { card.dataset.index = i; });
    const count = $('[data-count]', wrap);
    const empty = $('[data-empty]', wrap);
    const sort = $('[data-sort]', wrap);
    const apply = (key) => {
      let shown = 0;
      cards.forEach((card) => {
        const visible = key === 'all' || (card.dataset.needs || '').split(' ').includes(key);
        card.classList.toggle('is-hidden', !visible);
        if (visible) shown += 1;
      });
      if (count) count.textContent = shown;
      if (empty) empty.hidden = shown > 0;
      $$('.chip--filter', wrap).forEach((chip) => {
        const on = chip.dataset.filter === key;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const url = new URL(window.location.href);
      if (key === 'all') url.searchParams.delete('necesidad');
      else url.searchParams.set('necesidad', key);
      window.history.replaceState({}, '', url.toString());
    };
    wrap.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-filter]');
      if (chip) apply(chip.dataset.filter);
    });
    const initial = new URL(window.location.href).searchParams.get('necesidad');
    if (initial) apply(initial);
    if (sort) {
      sort.addEventListener('change', () => {
        const mode = sort.value;
        cards
          .slice()
          .sort((a, b) => {
            if (mode === 'title') return a.dataset.title.localeCompare(b.dataset.title, 'es');
            if (mode === 'created') return Number(b.dataset.created) - Number(a.dataset.created);
            return Number(a.dataset.index) - Number(b.dataset.index);
          })
          .forEach((card) => grid.appendChild(card));
      });
    }
  });

  /* ---------- Diagnóstico de piel ---------- */
  const AGE_TIPS = {
    30: 'Antes de los 30 la prioridad es prevenir: protección solar diaria, antioxidantes e hidratación constante.',
    45: 'Entre los 30 y los 45 aparecen las primeras líneas: es el momento ideal para introducir retinoides y péptidos de forma progresiva.',
    60: 'Entre los 45 y los 60 la piel pierde densidad: combina la renovación nocturna con activos reafirmantes e hidratación intensa.',
    61: 'A partir de los 60 la piel pide confort: prioriza texturas nutritivas, péptidos y una renovación suave y constante.'
  };
  $$('[data-quiz]').forEach((quiz) => {
    const form = $('[data-quiz-form]', quiz);
    const steps = $$('.quiz__step', quiz);
    const bar = $('[data-quiz-bar]', quiz);
    const back = $('[data-quiz-back]', quiz);
    const result = $('[data-quiz-result]', quiz);
    const pool = $('[data-quiz-pool]', quiz);
    let map = {};
    try { map = JSON.parse($('[data-quiz-map]', quiz).textContent); } catch (err) { map = {}; }
    let step = 0;

    const show = (i) => {
      step = i;
      steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
      if (bar) bar.style.width = `${((i + 1) / (steps.length + 1)) * 100}%`;
      if (back) back.hidden = i === 0;
    };

    const finish = () => {
      const fd = new FormData(form);
      const concern = fd.get('concern') || 'arrugas';
      const skin = fd.get('skin') || 'normal';
      const age = fd.get('age') || '45';
      const rec = map[concern] || Object.values(map)[0];
      if (!rec) return;
      const useSensitive = skin === 'sensible' && rec.sensitive && rec.sensitive.length;
      const ids = useSensitive ? rec.sensitive : rec.products;
      const list = $('[data-result-products]', result);
      list.innerHTML = '';
      let total = 0;
      const items = [];
      ids.forEach((id, i) => {
        const tpl = pool && pool.content.querySelector(`[data-pid="${id}"]`);
        if (!tpl) return;
        const li = tpl.cloneNode(true);
        const stepLabel = li.querySelector('[data-step-label]');
        if (stepLabel) stepLabel.textContent = `Paso ${i + 1}`;
        list.appendChild(li);
        if (li.dataset.available === 'true') {
          total += Number(li.dataset.price);
          items.push({ id: Number(li.dataset.variant), quantity: 1 });
        }
      });
      $('[data-result-title]', result).textContent = rec.title;
      $('[data-result-text]', result).textContent = useSensitive
        ? `${rec.text} Como tu piel es sensible, hemos elegido las fórmulas más respetuosas.`
        : rec.text;
      $('[data-result-tip]', result).textContent = AGE_TIPS[age] || '';
      $('[data-result-total]', result).textContent = money(total);
      const addBtn = $('[data-quiz-add]', result);
      addBtn.disabled = items.length === 0;
      addBtn.onclick = () => addItems(items, addBtn);
      form.hidden = true;
      result.hidden = false;
      if (bar) bar.style.width = '100%';
      result.focus({ preventScroll: true });
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    form.addEventListener('change', (e) => {
      if (e.target.type !== 'radio') return;
      setTimeout(() => (step < steps.length - 1 ? show(step + 1) : finish()), 220);
    });
    if (back) back.addEventListener('click', () => show(Math.max(0, step - 1)));
    const restart = $('[data-quiz-restart]', quiz);
    if (restart) {
      restart.addEventListener('click', () => {
        form.reset();
        result.hidden = true;
        form.hidden = false;
        show(0);
      });
    }
    show(0);
  });
})();
